import React from 'react';
import { Link } from 'react-router-dom';
import { SubPageLayout } from '../components/SubPageLayout';
import { useSeo } from '../lib/seo';

export default function Impressum() {
  useSeo({
    title: 'Impressum | Smart Post Solution',
    description: 'Impressum von Smart Post Solution – Bernd Deninger, Senior Consultant für Briefkonsolidierung, Versandlogistik und Poststellenorganisation.',
    canonical: 'https://smart-post-solution.de/impressum',
  });

  return (
    <SubPageLayout>
      <div className="max-w-3xl mx-auto px-6 lg:px-12 py-16 lg:py-24" data-testid="impressum-page">
        <h1 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-10">Impressum</h1>
        <div className="space-y-8 text-slate-700">
          <section>
            <h2 className="font-semibold text-lg mb-2 text-slate-900">Angaben gemäß § 5 DDG</h2>
            <p>
              Smart Post Solution<br />
              Bernd Deninger<br />
              Senior Consultant<br />
              Unterreichenbacher Straße 3<br />
              75331 Engelsbrand
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-lg mb-2 text-slate-900">Kontakt</h2>
            <p>
              E-Mail: <span className="text-slate-600" aria-label="E-Mail-Adresse in verschleierter Schreibweise">info [at] smart-post-solution [punkt] de</span><br />
              <span className="text-xs text-slate-500 italic">
                Zur Vermeidung von Spam bewusst nicht als Link. Bitte nutzen Sie unser{' '}
                <Link to="/#kontakt" className="text-slate-700 hover:text-slate-900 underline">
                  Kontaktformular
                </Link>.
              </span><br />
              Office: <a href="tel:+497235975942" className="text-slate-600 hover:text-slate-900">07235 - 9759-427</a><br />
              Mobil: <a href="tel:+4915233886484" className="text-slate-600 hover:text-slate-900">0152 33 88 64 84</a>
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-lg mb-2 text-slate-900">Umsatzsteuer-ID</h2>
            <p>
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
              DE356867011
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-lg mb-2 text-slate-900">Berufsbezeichnung</h2>
            <p>
              Senior Consultant für Briefkonsolidierung, Versandlogistik und Poststellenorganisation
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-lg mb-2 text-slate-900">Verbraucherstreitbeilegung</h2>
            <p>
              Wir sind nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-lg mb-2 text-slate-900">Haftung für Inhalte</h2>
            <p className="text-sm leading-relaxed">
              Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen
              Gesetzen verantwortlich. Als Diensteanbieter sind wir jedoch nicht verpflichtet, übermittelte
              oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf
              eine rechtswidrige Tätigkeit hinweisen.
            </p>
          </section>
        </div>
      </div>
    </SubPageLayout>
  );
}
